import { render } from "./MenuRoot.vue?vue&type=template&id=096f0a3a"
import script from "./MenuRoot.vue?vue&type=script&lang=js"
export * from "./MenuRoot.vue?vue&type=script&lang=js"

import "./MenuRoot.vue?vue&type=style&index=0&id=096f0a3a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__